import {AddNewUnitModel} from "@app/models/commissioning-sheet/add-new unit.model";

export class GetAllDisciplines {
  static readonly type = '[CommissioningSheetState] Get All Discipline ';
}

export class GetAllSystemTypes {
  static readonly type = '[CommissioningSheetState] Get All System Types ';
}

export class GetSystemTypes {
  static readonly type = 'CommissioningSheetState] Get System Types ';
  constructor(public id: number) {
  }
}

export class RemoveSystemTypes {
  static readonly type = '[CommissioningSheetState] Remove System Types ';
}

export class AddNewUnit {
  static readonly type = '[CommissioningSheetState ] Add New Unit';

  constructor(public payload: AddNewUnitModel ) {
  }
}

export class RemoveNewUnitState {
  static readonly type = '[CommissioningSheetState ] Removing New Unit State';
}
